<template>
	<div class="main" v-title data-title="零部件网站隐私权保护协议">
		<iHeader></iHeader>
		<div class="flexRow justBetween barprebox mt25">
			<div class="barprebox bgwhite">
				<div class="mt25 ml20 txc">
					<div class="mt10" style="border-bottom: 1px solid #ccc;">
						<h1 class="color1 font18 item1 txc">隐私权保护协议</h1>
						<p class="txc pd20 font12">发布日期:2021.1.1</p>
					</div>
				</div>
				<div class="formWBase txl">
					<div class="list-item">
						<div class="noticeD ">
							<p>
								石家庄沐风网络科技有限公司（以下简称“我们”）重视所有使用沐风零部件平台享受各项互联网服务用户的隐私。
								我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：
								权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。同时，我们承诺，
								我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。您在使用我们的服务时，请务必认真阅读本《隐私权保护协议》
								中规定的所有权利和限制，在需要时，按照本《隐私权保护协议》的指引，作出您认为适当的选择。我们可能会收集和使用您的相关信息。
								我们希望通过本《隐私权保护协议》向您说明，在使用我们的服务时，我们如何收集、使用、储存和分享这些信息，以及我们为您提供的访问、更新、
								控制和保护这些信息的方式。如您对本《隐私权保护协议》里所提的相关事宜有任何问题，请通过fuwu@mfcad.com与我们联系。 如用户不同意本协议，
								可以主动拒绝、取消沐风零部件提供的服务；用户一旦使用沐风零部件服务（包括但不限于用户对沐风零部件所有服务内容、软件、客户端的下载、安装、
								使用、浏览、帐号获取和登录等行为），即视为用户已了解并完全同意本协议各项内容，包括对本协议随时所做的任何修改。
							</p>
							<p class="fw">
								我们处理个人信息的法律依据
							</p>
							<p>
								本隐私政策制定的法律依据为《中华人民共和国消费者权益保护法》、《中华人民共和国网络安全法》、《中华人民共和国电子商务法》、《信息安全技术个人信息安全规范》以及其他涉及公民个人信息的相关法律法规。
								通常，我们会基于本隐私政策提示的功能收集您的个人信息。某些情况下，如果涉及其他信息的收集我们会单独向您出示个人信息保护说明条款。
							</p>
							<p class="fw">
								本隐私政策的适用范围
							</p>
							<p>
								本隐私政策适用于您使用本平台的产品或服务时使用。
							</p>
							<p>原则上，我们仅会出于本隐私政策所述的以下目的，收集和使用您的个人信息。我们是信息发布平台，所涉信息较多，如果超过以下目的收集和使用您的个人信息时我们会单独向您提示并征得您的同意。</p>
							<P class="fw">帮助您成为我们的注册登录用户</P>
							<p>
								您自行注册成为我们的用户
							</p>
							<p>
								您在使用我们提供的服务时，首先需要成为我们的注册登录用户。当您注册账户时，您需要向我们提供您准备使用的账号、姓名、手机号码这些信息，是为了发送、告知相应的产品服务广告信息，您如果不同意接收相关信息，您可以通过联系相应客服退订功能或相关提示进行退订；当您注册或绑定了手机号，零部件厂家可能会获取您的联系方式用以报价等用途，您如果不同意厂家联系您，我们将无法为您提供报价等相关服务。
							</p>
							<p>
								您创建的用户账号的命名及使用应遵守相关法律法规并符合网络道德。用户账号中不能含有任何侮辱、威胁、淫秽、谩骂等侵害他人合法权益的文字。用户账号将作为您在平台上活动的标识，用以区别平台上其他用户。
							</p>
							<p>
								当您注册账户时，您需要输入您的手机号码+验证码，或使用第三方登录+手机号方式。当您的账户密码遗失时，可以通过联系我们解决。
							</p>
							<p>当您注册账户后需要个人实名认证时，您需要输入您的姓名和身份证号，通过个人身份进行实名认证。根据《中华人民共和国网络安全法》对账号实名制要求，减少谣言、黑客攻击等各种威胁网络安全的事件发生，我们要求您提供真实身份信息，否则，您将实名失败无法继续使用网站。</p>
							<p>当您是企业时，需提供企业相关信息，公司名、运营者姓名、身份证号、手机号码，以上信息仅使用于网站作为企业用户进行实名认证使用。以便提高企业信用度，便于您开展业务。</p>
							<p>您提供的上述信息，将在您使用我们服务期间持续授权我们使用。在您注销账号时，我们将停止使用并删除上述信息。</p>
							<p class="fw">客户服务</p>
							<p>当您向我们申诉或进行咨询时，为了方便与您联系或帮助您解决问题，我们可能需要您提供个人姓名、手机号码信息。如您拒绝提供上述信息，可能部分功能无法使用，同时无法向您及时反馈申诉或咨询结果。
会员在本平台删除账号或后期不继续使用，注销账号时会员可以通过拨打联系方式0311-85272959联系我们，核对信息确认此账号为本人操作使用后方以进行注销，我司承诺会在2个工作日内清除所有个人信息资料。</p>
							<p class="fw">征得授权同意的例外</p>
							<p>1、与公共安全、公共卫生、重大公共利益直接相关的；/p>
							<p>2、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
							<p>3、根据您的要求签订和履行合同所必需的；</p>
							<p>4、法律法规规定的其他情形。</p>
							<p class="fw">我们可能收集的信息</p>
							<p>我们提供服务时，可能会收集、储存和使用下列与您有关的信息。如果您不提供相关信息，可能无法注册成为我们的用户、享受我们提供的某些服务，或者即便我们可以继续向您提供一些服务，也无法达到该服务拟达到的效果。</p>
							<p class="fw">需要您提供的信息</p>
							<p>1、您在注册我们的账户或使用我们的服务时，向我们提供的相关个人信息，例如电话号码、姓名和身份证号等。</p>
							<p>2、您在注册我们的企业账户或使用我们的服务时，向我们提供的相关个人信息，例如企业名、运营着电话号码、姓名和身份证号等。</p>
							<p>3、您通过我们的服务向其他方提供的共享信息，以及您使用我们的服务时所储存的信息。</p>
							<p>4、其他方使用我们的服务时所提供有关您的共享信息。</p>
							<p class="fw">我们如何收集信息</p>
							<p>1、我们或我们的第三方合作伙伴，可能通过cookies和web beacon收集和使用您的信息，并将该等信息储存为日志信息。</p>
							<p>2、我们使用自己的cookies和web beacon，目的是为您提供更个性化的用户体验和服务，并用于以下用途：</p>
							<p>• 记住您的身份。例如：cookies和web beacon有助于我们辨认您作为我们的注册用户的身份，或保存您向我们提供的有关您的喜好或其他信息。</p>
							<p>• 分析您使用我们服务的情况。例如，我们可利用cookies和web beacon来了解您使用我们的服务进行什么活动，或哪些网页或服务最受您的欢迎。</p>
							<p>3、我们为上述目的使用cookies和web beacon的同时，可能将通过cookies和web beacon收集的非个人身份信息，经统计加工后提供给广告商或其他合作伙伴，用于分析用户如何使用我们的服务，并用于厂商报价服务使用。</p>
							<p>4、您可以通过浏览器设置拒绝或管理cookies或web beacon。但请注意，如果停用cookies或web beacon，您有可能无法享受最佳的服务体验，某些服务也可能无法正常使用。</p>
							<p class="fw">我们如何处理未成年人的个人信息</p>
							<p>1、我们主要为信息发布平台，我们的服务主要面向成年人（原则上18周岁以上为成年人，16周岁以上且以自己的劳动收入为主要生活来源的我们亦视为成年人）。若您是未成年人，在使用我们的产品和/或服务前，您应在监护人的陪同下阅读本隐私政策，并应确保已征得您的监护人同意后使用我们的服务并向我们提供您的信息。 我们会根据国家相关法律法规的规定着重保护未成年人的个人信息。</p>
							<p>2、如您的监护人不同意您按照本隐私政策使用我们的服务或向我们提供信息，请您立即终止使用我们的服务并及时通知我们。</p>
							<p>3、对于经父母或法定监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。</p>
							<p>4、若您是未成年人的监护人，当您对您所监护的未成年人使用我们的服务或其向我们提供的用户信息有任何疑问时，请您及时与我们联系。我们将根据国家相关法律法规及本隐私政策的规定保护未成年人用户信息的保密性及安全性。如果我们发现自己在未事先获得可证实的父母或法定监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。</p>
							<p class="fw">我们获取的您的信息</p>
							<p class="fw">您使用我们服务时我们可能收集如下信息：</p>
							<p>日志信息指您使用我们服务时，系统可能会通过cookies、web beacon或其他方式自动采集的技术信息包括：设备或软件信息，例如您的移动设备、网页浏览器或您用于接入我们的服务的其他程序所提供的配置信息、您的IP地址和您的移动设备所用的版本和设备识别码。</p>
							<p class="fw">如何访问和控制您的信息</p>
							<p>我们将尽量采取适当的技术手段，保证您可以访问、更新和更正您的注册信息或使用我们的服务时提供的其他个人信息。在访问、更新、更正和删除您的个人信息时，我们可能会要求您进行身份验证，以保障您的账户安全。</p>
							<p>• 对于通过cookies和web beacon收集的您的信息，我们还在以下“COOKIES、日志档案和WEB BEACON”部分说明了向您提供的选择机制。</p>
							<p class="fw">我们可能分享的信息</p>
							<p>除以下情形外，未经您同意，我们以及我们的关联公司不会与任何第三方分享您的个人信息：</p>
							<p>我们以及我们的关联公司，可能将您的个人信息与我们的关联公司、合作伙伴及第三方服务供应商、承包商及代理（例如代表我们发出电子邮件或推送通知的通讯服务提供商、为我们提供位置数据的地图服务供应商）分享（他们可能并非位于您所在的法域），用作下列用途：</p>
							<p>• 向您提供我们的服务。</p>
							<p>• 实现“我们可能如何使用信息”部分所述目的。</p>
							<p>• 履行我们在本《隐私权保护协议》中的义务和行使我们的权利。</p>
							<p>• 理解、维护和改善我们的服务。如我们或我们的关联公司与任何上述第三方分享您的个人信息，我们将努力确保该等第三方在使用您的个人信息时遵守本《隐私权保护协议》及我们要求其遵守的其他适当的保密和安全措施。随着我们业务的持续发展，我们以及我们的关联公司有可能进行合并、收购、资产转让或类似的交易，您的个人信息有可能作为此类交易的一部分而被转移。我们将在转移前通知您。</p>
						    <p>5、我们或我们的关联公司还可能为以下需要而保留、保存或披露您的个人信息：</p>
						    <p>遵守适用的法律法规。</p>
						    <p>遵守法院命令或其他法律程序的规定。</p>
						    <p>遵守相关政府机关的要求。</p>
						    <p>为遵守适用的法律法规、维护社会公共利益，或保护我们的客户、或我们公司、其他用户或雇员的人身和财产安全或合法权益所合理必需的用途。</p>
							<p class="fw">信息安全</p>
							<p>我们使用各种安全技术和程序，以防信息的丢失、不当使用、未经授权阅览或披露。例如，在某些服务中，我们将利用加密技术（例如SSL）来保护您提供的个人信息。但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。</p>
							<p class="fw">您分享的信息</p>
							<p>我们的多项服务，可让您不仅与自己的社交网络，也与使用该服务的所有用户公开分享您的相关信息，例如，您在我们的服务中所上传或发布的信息（包括您公开的个人信息、您建立的名单）、您对其他人上传或发布的信息作出的回应，以及包括与这些信息有关的位置数据和日志信息。使用我们服务的其他用户也有可能分享与您有关的信息（包括位置数据和日志信息）。特别是，我们的社交媒体服务，是专为使您与世界各地的用户共享信息而设计，您可以使共享信息实时、广泛地传递。只要您不删除共享信息，有关信息会一直留存在公共领域；即使您删除共享信息，有关信息仍可能由其他用户或不受我们控制的非关联第三方独立地缓存、复制或储存，或由其他用户或该等第三方在公共领域保存。</P>
							<P>因此，请您谨慎考虑通过我们的服务上传、发布和交流的信息内容。在一些情况下，您可通过我们某些服务的隐私设定来控制有权浏览您共享信息的用户范围。如要求从我们的服务中删除您的相关信息，请通过该等特别服务条款提供的方式操作。</P>
							<P>您分享的敏感个人信息</P>
							<P>某些个人信息因其特殊性可能被认为是敏感个人信息，例如您的种族、宗教、个人健康和医疗信息等。相比其他个人信息，敏感个人信息受到更加严格的保护。</P>
							<P>请注意，您在使用我们的服务时所提供、上传或发布的内容和信息（例如有关您社交活动的照片等信息），可能会泄露您的敏感个人信息。您需要谨慎地考虑，是否在使用我们的服务时披露相关敏感个人信息。 您同意按本《隐私保护协议》所述的目的和方式来处理您的敏感个人信息。</P>
						    <P class="fw">我们可能向您发送邮件与信息</P>
							<P>我们可能在必要时（例如因系统维护而暂停某一项服务时）向您发出与服务有关的公告。您可能无法取消这些与服务有关、性质不属于推广的公告。</P>
							<P class="fw">未成年人使用我们的服务</P>
							<P>我们鼓励父母或监护人指导未满十八岁的未成年人使用我们的服务。我们建议未成年人鼓励他们的父母或监护人阅读本《隐私保护协议》，并建议未成年人在提交的个人信息之前寻求父母或监护人的同意。</P>
							<P class="fw">隐私保护协议的适用范围</P>
							<P>除某些特定服务外，本网站所有服务均适用本《隐私保护协议》。针对某些特定服务的特定隐私政策，将更具体地说明我们在该等服务中如何使用您的信息。该特定服务的隐私政策构成本《隐私保护协议》的一部分。如相关特定服务的隐私政策与本《隐私保护协议》有不一致之处，适用该特定服务的隐私政策。
请您注意，本《隐私保护协议》不适用于以下情况：</P>
							<P>• 通过我们的服务而接入的第三方服务（包括任何第三方网站）收集的信息。</P>
							<P>• 通过在我们服务中进行广告服务的其他公司或机构所收集的信息。</P>
							<p class="fw">特殊免责</p>
							<p>1、为了提供更好的用户服务，沐风零部件会在用户选择服务或提供信息的情况时存储注册信息。请用户在注册时及时、详尽及准确的提供个人信息，并在发生变化时不断更新、完善，如果因注册信息不真实、有误而引起的问题，由用户自行承担相应的后果。</p>
							<p>2、请用户不要将的帐号、密码转让或出借予他人使用，互联网上不排除因黑客行为或用户的保管疏忽导致帐号、密码遭他人非法使用或隐私信息外泄，此类情况与沐风零部件无关。</p>
							<p class="fw">《隐私保护协议》的变更修改</p>
							<p>我们可能随时修改本《隐私保护协议》的条款，该等修改构成本《隐私保护协议》的一部分。如该等修改造成您在本《隐私保护协议》下权利的实质减少，我们将在修改生效前通过在主页上显著位置提示或向您发送电子邮件或以其他方式通知您，在该种情况下，若您继续使用我们的服务，即表示同意受经修订的本《隐私保护协议》的约束。</p>
							
							
						</div>
					</div>
				</div>
			</div>
		</div>
		<v-footer></v-footer>
	</div>
</template>

<script>
	// 公共头部组件
	import iHeader from "@/components/indexheader"
	import vnav from "@/components/leftnav"
	import vFooter from "@/components/Footer"
	import "@/assets/cont-01.css";
	import Vue from 'vue';
	import axios from 'axios';
	Vue.prototype.$axios = axios;
	import Cookies from 'js-cookie'
	export default {
		components: {
			iHeader,
			vFooter,
			vnav,
		},
		data() {
			return {
				noticeinfo: [],
				goods_id: ''
			};
		},
		created() {},
		methods: {

		}
	}
</script>

<style scoped>
	.list-item .noticeD {
		position: relative;
		padding: 10px 20px;
		font-size: 14px;
	}

	.list-item .noticeD p {
		font-size: 16px;
		color: #717171;
		font-weight: 400;
		line-height: 26px !important;
		margin: 0 0 16px;
		overflow-x: auto;
	}

	.Ctitle {
		height: 35px;
		line-height: 35px;
		vertical-align: middle;
		margin-right: 20px;
		border-bottom: 1px solid #ccc;
	}

	.el-divider {
		margin: 12px 0px;
	}

	.fw {
		font-weight: bold !important;
	}
</style>



// WEBPACK FOOTER //
// src/pages/notice/priagreement.vue